//
//
//
//
//
//
//

export default {
  name: 'VOverlayPreloader',
}
